<template>
    <el-dialog
        title="编辑记录"
        :visible="true"
        width="900px"
        append-to-body
        :custom-class="'editRecordDialog'"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="beforeClose"
    >
        <el-table
            :data="tableData"
            border
            height="200"
            width="100%"
        >
            <el-table-column
                prop="createUserName"
                label="编辑人"
                min-width="150"
            ></el-table-column>
            <el-table-column
                prop="createTime"
                label="编辑提交时间"
                min-width="150"
            ></el-table-column>
            <el-table-column
                prop="requestUrl"
                label="审批链接"
                min-width="400"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <el-button type="text" @click="handleClick(scope.row)">{{ scope.row.requestUrl }}</el-button>
                </template>
            </el-table-column>
            <el-table-column
                prop="iflowStatusName"
                label="审批状态"
                min-width="150"
            ></el-table-column>
        </el-table>
    </el-dialog>
</template>

<script>
import { queryEditRecord } from '../../../../api/driverPaymentDurationConfig.js';
import { urlToIflow } from '../util.js';
export default {
    name: 'EditRecordDialog',
    props: {
        editRecordDialogShow: {
            type: Boolean,
            default () {
                return false;
            }
        },
        componentsData: {
            type: Object,
            default () {
                return {};
            }
        },
        dictData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            tableData: [],
            loading: false
        };
    },
    mounted () {
        this.componentsData.id && this.queryEditRecord();
    },
    methods: {
        beforeClose () {
            this.$emit('update:editRecordDialogShow', false);
        },
        queryEditRecord () {
            this.loading = true;
            queryEditRecord({ id: this.componentsData.id })
                .then(res => {
                    if (res && +res.code === 0) {
                        this.tableData = this.formatTableData(res.data || []);
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        formatTableData (data) {
            if (!data.length) return [];
            data.forEach(item => {
                item.iflowStatusName = this.dictData.OTP_APPLY_STATUS[item.applyStatus] || '';
                item.requestUrl = urlToIflow('/otp/transport-center/payment-duration-mip', { requestId: item.requestId });
            });
            return data;
        },
        handleClick (row) {
            if (row.requestId) {
                this.$emit('update:editRecordDialogShow', false);
                this.$router.push({
                    path: '/otp/transport-center/payment-duration-mip',
                    query: {
                        requestId: row.requestId
                    }
                });
            }
        }
    }
};
</script>

<style lang="less">
.editRecordDialog {
    .el-dialog__body {
        .el-table--border {
            border-right: 1px solid #ebeef5;
            border-bottom: 1px solid #ebeef5;
        }
    }
}
</style>
